<template>
  <div class="g-tabs-body">
      <slot></slot>
  </div>
</template>

<script>
export default {
    name: 'g-tabs-body'
}
</script>

<style lang="scss" scoped>
.g-tabs-body{
  margin-top:15px;
  padding-left:1em;
}
</style>